import ServicePage from "../Common/ServicePage";

// Wiring specific services
const wiringServices = [
  { 
    id: 1, 
    name: 'Room Wiring Service', 
    provider: 'RoomWire Experts', 
    image: 'https://placehold.co/600x400?text=Room+Wiring', 
    rating: 4.78, 
    reviews: 700, 
    price: 1500, 
    category: 'Room Wiring' 
  },
  { 
    id: 2, 
    name: 'Full House Wiring', 
    provider: 'HomeWire Professionals', 
    image: 'https://placehold.co/600x400?text=Full+House+Wiring', 
    rating: 4.85, 
    reviews: 500, 
    price: 4000, 
    category: 'Full House Wiring' 
  },
  { 
    id: 3, 
    name: 'Cable Replacement Service', 
    provider: 'CableCare Solutions', 
    image: 'https://placehold.co/600x400?text=Cable+Replacement', 
    rating: 4.80, 
    reviews: 450, 
    price: 500, 
    category: 'Cable Work' 
  },
  { 
    id: 4, 
    name: 'Light Point Wiring', 
    provider: 'LightWire Specialists', 
    image: 'https://placehold.co/600x400?text=Light+Point+Wiring', 
    rating: 4.82, 
    reviews: 600, 
    price: 300, 
    category: 'Lighting Wiring' 
  },
  { 
    id: 5, 
    name: 'Kitchen Wiring Service', 
    provider: 'KitchenWire Experts', 
    image: 'https://placehold.co/600x400?text=Kitchen+Wiring', 
    rating: 4.79, 
    reviews: 350, 
    price: 1200, 
    category: 'Kitchen Wiring' 
  },
  { 
    id: 6, 
    name: 'Bathroom Wiring Service', 
    provider: 'BathWire Professionals', 
    image: 'https://placehold.co/600x400?text=Bathroom+Wiring', 
    rating: 4.83, 
    reviews: 280, 
    price: 800, 
    category: 'Bathroom Wiring' 
  },
  { 
    id: 7, 
    name: 'Office Wiring Solution', 
    provider: 'OfficeWire Solutions', 
    image: 'https://placehold.co/600x400?text=Office+Wiring', 
    rating: 4.86, 
    reviews: 400, 
    price: 3500, 
    category: 'Commercial Wiring' 
  },
  { 
    id: 8, 
    name: 'Concealed Wiring Service', 
    provider: 'ConcealWire Experts', 
    image: 'https://placehold.co/600x400?text=Concealed+Wiring', 
    rating: 4.88, 
    reviews: 550, 
    price: 2000, 
    category: 'Concealed Wiring' 
  },
  { 
    id: 9, 
    name: 'Outdoor Wiring Installation', 
    provider: 'OutdoorWire Professionals', 
    image: 'https://placehold.co/600x400?text=Outdoor+Wiring', 
    rating: 4.75, 
    reviews: 320, 
    price: 1000, 
    category: 'Outdoor Wiring' 
  },
  { 
    id: 10, 
    name: 'UPS/Inverter Wiring', 
    provider: 'PowerBackup Wiring', 
    image: 'https://placehold.co/600x400?text=UPS+Wiring', 
    rating: 4.81, 
    reviews: 380, 
    price: 800, 
    category: 'Power Backup Wiring' 
  },
  { 
    id: 11, 
    name: 'Fan Point Wiring', 
    provider: 'FanWire Specialists', 
    image: 'https://placehold.co/600x400?text=Fan+Point+Wiring', 
    rating: 4.77, 
    reviews: 420, 
    price: 250, 
    category: 'Fan Wiring' 
  },
  { 
    id: 12, 
    name: 'Socket Point Wiring', 
    provider: 'SocketWire Services', 
    image: 'https://placehold.co/600x400?text=Socket+Wiring', 
    rating: 4.84, 
    reviews: 480, 
    price: 200, 
    category: 'Socket Wiring' 
  }
];

const wiringCategories = ['Room Wiring', 'Full House Wiring', 'Kitchen Wiring', 'Bathroom Wiring', 'Commercial Wiring', 'Concealed Wiring', 'Outdoor Wiring', 'Power Backup Wiring', 'Lighting Wiring', 'Fan Wiring', 'Socket Wiring', 'Cable Work'];

const packages = [
  { id: 1, title: "Room Wiring", rating: "4.78 (700 reviews)", price: 1500, originalPrice: 1800, icon: "🔌" },
  { id: 2, title: "Full House Wiring", rating: "4.85 (500 reviews)", price: 4000, originalPrice: 4500, icon: "🏠" },
];

const miniServices = [
  { id: 101, title: "Cable Replacement", price: 500, icon: "🔧" },
  { id: 102, title: "Light Point Wiring", price: 300, icon: "💡" },
];

export default function Wiring() {
  return (
    <ServicePage
      serviceName="Wiring"
      packages={packages}
      miniServices={miniServices}
      customServices={wiringServices}
      customCategories={wiringCategories}
      isCustomService={true}
    />
  );
}